import {
  MANAGE_OWNER_MANAGER_REQUEST,
  MANAGE_OWNER_MANAGER_SUCCESS,
  MANAGE_OWNER_MANAGER_FALIURE,
  GET_OWNER_MANAGER_REQUEST,
  GET_OWNER_MANAGER_SUCCESS,
  GET_OWNER_MANAGER_FALIURE,
  UPDATE_PHONE_NUMBERS_REQUEST,
  UPDATE_PHONE_NUMBERS_SUCCESS,
  UPDATE_PHONE_NUMBERS_FALIURE,
  GET_PHONE_NUMBERS_REQUEST,
  GET_PHONE_NUMBERS_SUCCESS,
  GET_PHONE_NUMBERS_FALIURE,
  RESET_ACCOUNT
} from './AccountSettingsConstants'

const intialstate = {
  is_loading : false,
  success_status : false,
  get_owner_manager : null,
  owner_manager : null,
  get_phone_numbers : null,
  phone_numbers : null,
  get_error : ''
}

const AccountSettingsReducers = (state = intialstate,action) =>{
  switch(action.type){
    case RESET_ACCOUNT : return {
      ...state,
      is_loading: false,
      success_status: false,
      owner_manager: null,
      phone_numbers: null,
      get_error: null
    }
    case MANAGE_OWNER_MANAGER_REQUEST : return {
      ...state,
      is_loading: true,
      success_status: false,
      owner_manager: null,
      get_error: null
    }
    case MANAGE_OWNER_MANAGER_SUCCESS : return {
      ...state,
      is_loading: false,
      success_status: true,
      owner_manager: action.payload
    }
    case MANAGE_OWNER_MANAGER_FALIURE : return {
      ...state,
      is_loading: false,
      success_status: false,
      get_error:action.payload
    }

    case GET_OWNER_MANAGER_REQUEST : return {
      ...state,
      is_loading: true,
      success_status: false,
      get_owner_manager: null,
      get_error: null
    }
    case GET_OWNER_MANAGER_SUCCESS : return {
      ...state,
      is_loading: false,
      success_status: true,
      get_owner_manager: action.payload
    }
    case GET_OWNER_MANAGER_FALIURE : return {
      ...state,
      is_loading: false,
      success_status: false,
      get_error:action.payload
    }

    case UPDATE_PHONE_NUMBERS_REQUEST : return {
      ...state,
      is_loading: true,
      success_status: false,
      phone_numbers: null,
      get_error: null
    }
    case UPDATE_PHONE_NUMBERS_SUCCESS : return {
      ...state,
      is_loading: false,
      success_status: true,
      phone_numbers: action.payload
    }
    case UPDATE_PHONE_NUMBERS_FALIURE : return {
      ...state,
      is_loading: false,
      success_status: false,
      get_error:action.payload
    }

    case GET_PHONE_NUMBERS_REQUEST : return {
      ...state,
      is_loading: true,
      success_status: false,
      get_phone_numbers: null,
      get_error: null
    }
    case GET_PHONE_NUMBERS_SUCCESS : return {
      ...state,
      is_loading: false,
      success_status: true,
      get_phone_numbers: action.payload
    }
    case GET_PHONE_NUMBERS_FALIURE : return {
      ...state,
      is_loading: false,
      success_status: false,
      get_error:action.payload
    }

    default: return state
  }

}

export default AccountSettingsReducers
